define.alias("ember-math-helpers/helpers/asin", "calendar/helpers/asin");